<template>
  <Transition name="fade">
    <div
      v-if="showWarning"
      class="fixed bottom-4 right-4 bg-orange-500 text-white px-4 py-3 rounded-xl shadow-lg z-40 flex items-center gap-3"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span class="font-medium">
        Návrat na hlavní stránku za {{ remainingSeconds }}s
      </span>
    </div>
  </Transition>
</template>

<script setup>
import { computed, toRef } from 'vue'
import { useInactivityTimer } from '../../composables/useInactivityTimer'

const props = defineProps({
  timeout: {
    type: Number,
    default: 60
  }
})

const emit = defineEmits(['timeout'])

const { remainingSeconds } = useInactivityTimer(props.timeout, () => {
  emit('timeout')
})

// Show warning when less than 15 seconds remain
const showWarning = computed(() => remainingSeconds.value <= 15 && remainingSeconds.value > 0)
</script>
